import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { MDBTooltip } from "mdb-react-ui-kit";
import Moment from 'moment';
import {isWeekday} from "../functions/date";


function CalendarEntries(props) {
    const navigate = useNavigate();

    const [date, setDate] = useState(new Date());
    const [taskList, setTaskList] = useState([]);
    const [entriesList, setEntriesList] = useState([]);


    const dayEntryIsVacation = (entry, number) => {
        if (number === 1) {
            console.log(entry, entry.TaskIDs[number] !== -1 && entry.FirstNames[number] === null && entry.LastNames[number] === null);

        }
        return entry.TaskIDs[number] !== -1 && entry.FirstNames[number] === null && entry.LastNames[number] === null;
    }

    // fill whole month with tasks, if nothing planned add placeholder tasks with id -1
    const expandTasksOfCustomer = (ignoreTasks=false) => {
        const firstDayOfMonth = Moment(new Date(date.getFullYear(), date.getMonth(), 1)).format("YYYY-MM-DD");
        const lastDayOfMonth = Moment(new Date(date.getFullYear(), date.getMonth() + 1, 0)).format("YYYY-MM-DD");

        const extendedTasks = [];

        // starts with last day of last month
        let currentEndDay = Moment(new Date(firstDayOfMonth)).subtract(1, 'days').format("YYYY-MM-DD");

        if (!ignoreTasks) {
            for (let i = 0; i < taskList.length; i++) {
                if (taskList[i].StartDate > Moment(new Date(currentEndDay)).add(1, 'days').format("YYYY-MM-DD")) {
                    // start of new task is more than 1 day after currentEndDay (space)
                    const newEnd = Moment(new Date(taskList[i].StartDate)).subtract(1, 'days').format("YYYY-MM-DD");
                    // add placeholder -1 id task
                    extendedTasks.push({StartDate: Moment(new Date(currentEndDay)).add(1, 'days').format("YYYY-MM-DD"), EndDate: newEnd, TaskID: -1});
                }
                extendedTasks.push(taskList[i]);
                currentEndDay = taskList[i].EndDate;
            }
        }

        if (currentEndDay < lastDayOfMonth) {
            extendedTasks.push({StartDate: Moment(new Date(currentEndDay)).add(1, 'days').format("YYYY-MM-DD"), EndDate: lastDayOfMonth, TaskID: -1});
        }

        return extendedTasks;
    }

    const setCalenderEntries = () => {
        // return if month in task list does not match date (date loaded before task list)
        let ignoreTasks = false;
        if (taskList.length > 0 && date.getMonth() !== new Date(taskList[0].StartDate).getMonth()) {
            ignoreTasks = true;
        }

        const tasks = expandTasksOfCustomer(ignoreTasks);
        const firstDay = Moment(new Date(date.getFullYear(), date.getMonth(), 1)).format("YYYY-MM-DD");

        const entries = [];
        let plannedColor = 0;
        let monthDay = 0;
        let lastEndDay = firstDay;

        for (let i=0; i < tasks.length; i++) {

            if (i > 0 && tasks[i].TaskID !== -1 && Moment(tasks[i].StartDate).isSameOrBefore(Moment(lastEndDay))) {
                // overlapping
                console.log("overlapping");
                let d = Moment(Moment(tasks[i].StartDate).format("YYYY-MM-DD")).diff(Moment(Moment(lastEndDay).format("YYYY-MM-DD")));
                console.log(d);
                while (d > 0) {
                    if (tasks[i].EmployeeID === -1) {
                        // vacation
                        entries[monthDay-d].classes.push("vacation");
                    } else {
                        // non-vacation task
                        entries[monthDay-d].classes.push(plannedColor ? "planned1" : "planned2");
                    }
                    entries[monthDay-d].FirstNames.push(tasks[i].FirstName);
                    entries[monthDay-d].LastNames.push(tasks[i].LastName);
                    entries[monthDay-d].TaskIDs.push(tasks[i].TaskID);
                    d--;
                }
                monthDay = monthDay - d;
                tasks[i].StartDate = Moment(lastEndDay).add(1, 'days').format("YYYY-MM-DD");
            }

            const taskLength = (new Date(tasks[i].EndDate) - new Date(tasks[i].StartDate)) / (1000 * 3600 * 24) + 1;
            for (let k=0; k < taskLength; k++) {
                if (tasks[i].TaskID !== -1) {
                    const color = (tasks[i].EmployeeID === -1) ? "vacation" : (plannedColor ? "planned1" : "planned2");
                    entries.push({
                        classes: [color],
                        TaskIDs: [tasks[i].TaskID],
                        FirstNames: [tasks[i].FirstName],
                        LastNames: [tasks[i].LastName]
                    });
                }
                else {
                    const weekdayClass = isWeekday(new Date(date.getFullYear(), date.getMonth(), monthDay+1)) ? "" : "weekend";
                    entries.push({classes: [weekdayClass], TaskIDs: [tasks[i].TaskID]});
                }
                monthDay++;
            }
            if (tasks[i].TaskID >= 0 && tasks[i].EmployeeID !== -1) {
                plannedColor = (plannedColor +1) % 2;
            }
            lastEndDay = tasks[i].EndDate;
        }
        setEntriesList(entries);
    }

    useEffect(() => {
        setEntriesList([]);
        setTaskList([]);
        setDate(new Date(new Date().getFullYear(), new Date().getMonth() + Number(props.offset), 1));
        console.log("effect offset", props.offset);
    }, [props.offset]);

    useEffect(() => {
        setTaskList(props.tasks);
    }, [props.tasks]);

    useEffect(() => {
        setCalenderEntries();
    }, [taskList]);

    return (
        <>
        {entriesList.map((entry, tKey) => {
            // empty day
            if (entry.TaskIDs[0] === -1 && entry.TaskIDs.length === 1) {
                return (
                    <td key={tKey} className={entry.classes[0]}></td>
                );
            }

            // single task or vacation
            if (entry.TaskIDs[0] >= 0 && entry.TaskIDs.length === 1) {
                return (
                    <MDBTooltip
                        tag='td'
                        wrapperProps={{
                            className: entry.classes[0],
                            key: {tKey},
                            onClick: () => navigate("/task/"+entry.TaskIDs[0])
                        }}
                        placement='bottom'
                        title={ dayEntryIsVacation(entry, 0) ? "keine Betreuung" : entry.FirstNames[0]+" "+entry.LastNames[0] }
                    >
                    </MDBTooltip>
                );
            }

            // multiple tasks (overlapping)
            if (entry.TaskIDs[0] !== -1 && entry.TaskIDs.length === 2) {
                return (
                    <td key={tKey}>
                        <table className="inner-table">
                            <tr>

                                <MDBTooltip
                                    tag='td'
                                    wrapperProps={{
                                        className: "double " + entry.classes[0],
                                        onClick: () => navigate("/task/" + entry.TaskIDs[0])
                                    }}
                                    placement='bottom'
                                    title={ dayEntryIsVacation(entry, 0) ? "keine Betreuung" : entry.FirstNames[0] + " " + entry.LastNames[0] }
                                >
                                    .
                                </MDBTooltip>
                            </tr>

                            <tr>

                                <MDBTooltip
                                    tag='td'
                                    wrapperProps={{
                                        className: "double " + entry.classes[1],
                                        onClick: () => navigate("/task/" + entry.TaskIDs[1])
                                    }}
                                    placement='bottom'
                                    title={ dayEntryIsVacation(entry, 1) ? "keine Betreuung" : entry.FirstNames[1] + " " + entry.LastNames[1] }
                                >
                                    .
                                </MDBTooltip>
                            </tr>
                        </table>
                    </td>

                );
            }
        })}
        </>
    );
}

export default CalendarEntries;